import { render, staticRenderFns } from "./FileInputImage.vue?vue&type=template&id=04de32da&"
import script from "./FileInputImage.vue?vue&type=script&lang=js&"
export * from "./FileInputImage.vue?vue&type=script&lang=js&"
import style0 from "./FileInputImage.vue?vue&type=style&index=0&id=04de32da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports